import * as React from 'react'
import { ISearchProps } from "./ISearchProps"
import { ISearchState } from "./ISearchState"

import { connect } from "react-redux"
import { Link, withRouter } from 'react-router-dom'
import HeaderComponent from "../../components/homeHeader"
import MenuComponent from "../../components/menuComponent/MenuComponent"
import FooterComponent from "../../components/footerComponent/FooterComponent"
import MasonryComponent from "../../components/masonryComponent/MasonryComponent"
import MenuLeftemobile from "../../components/menuLeftMobile/MenuLeftemobile";

enum TYPE {
    INPUT = 'input',
    TAGS = 'tags'
}

class Search extends React.Component<ISearchProps, ISearchState> {

    constructor(props: ISearchProps) {
        super(props)

        this.state = {
            params: this.makeQueryWithTags([]), // empty array -> empty query,
            loading: true ,
            title: ''
        }
    }

    componentDidMount() {
        if (this.props.searchText instanceof Array) {
            this.setState({title : this.props.location.state})
        }

        this.handleSearch(this.props)
    }

    // tags with #
    makeQueryWithTags (tags: Array<string>): object {

        const shoulds = []

        tags.map((tag) => {
            const match = {}
            match['tags.text'] = tag
            shoulds.push({ match })
        })

        const q = {
            query: {
                nested: {
                    path: "tags",
                    query: {
                        bool: {
                            should: shoulds
                        }
                    }
                }
            }
        }

        return q
    }

    handleSearch (props) {

        let { searchText, tags, location  } = props

        if (! searchText)
            searchText = ''

        console.log('SEARCH PROPS', props)

        let  newParam = {
            "query": {
                "multi_match" : {
                    "query":    "No kk",
                    "type": "phrase_prefix",
                    "fields": [ "title", "text" ]
                }
            }
        }

        const type = location.search.split('=')[1]

        if (searchText instanceof Array) {
            this.setState({
                params: this.makeQueryWithTags(searchText),
                loading: false
            })
        } else {
            newParam.query.multi_match.query = searchText
            this.setState({
               // params: this.makeQueryWithTags(searchText ? [ `#${searchText}` ] : []),
                params: newParam,
                loading: false ,
                title: searchText
            })
        }
    }


    componentWillReceiveProps(nextProps: Readonly<ISearchProps>, nextContext: any): void {

        console.log(nextProps.location.state , 'naaame11111111')
        this.setState({title : nextProps.location.state})
        if (nextProps.searchText === this.props.searchText) {
            return
        }





            this.setState({loading: true , params : {} , title : ''} , ()=>{
                if (nextProps.searchText instanceof Array) {



                }

            this.handleSearch(nextProps)

        })

    }

    render() {



        return (
            <div>
                <MenuLeftemobile/>
                <HeaderComponent />
                <MenuComponent />
                <div
                    className={"container extraContainerHeight"}
                >
                    {
                        ! this.state.loading

                        ?   <MasonryComponent
                                title={this.state.title ? this.state.title  + ' :' : 'Results :'}
                                size={20}
                                url='https://search.giftounsi.placeholder.tn/gifs/_search'
                                params={this.state.params}
                                elastic={true}
                            />
                        :   <h2>Loading</h2>
                    }
                </div>

                <FooterComponent/>
            </div>
        );
    }
}

function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        authenticated: state.auth.authenticated,
        searchText: state.Gif.searchText,
        tags: state.categories.tagesByCategories
    }
}

export default connect(mapsStateToProps, null)(withRouter(Search))



// WEBPACK FOOTER //
// ./src/containers/search/Search.tsx